import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { mediaQuery } from '@clearscore/rainbow.tokens';
import IconNavigation from '@shared/icon-navigation';
import Drawer from '@clearscore/rainbow.drawer';
import { useHasSegmentationGroups } from '@clearscore/hooks.use-segmentation';
import { swapOffersAndBuild } from '@shared/cs-build-nav-test';

import styles from './index.css';

const BurgerMenu = ({
    initialIsOpen,
    routerTrackingSource,
    drawerDataId,
    onClose,
    hasBurgerMenu,
    isMoreBurgerMenu,
}) => {
    const [isOpen, setIsOpen] = useState(initialIsOpen);
    const hasBuild = useHasSegmentationGroups('build-v1:test');
    const hasNavB = useHasSegmentationGroups('build-v1:test-navB');

    useEffect(() => {
        setIsOpen(initialIsOpen);
    }, [setIsOpen, initialIsOpen]);

    // CS Build navigation test
    const modifyNavigation = (routes) => {
        if (hasBuild && hasNavB) {
            return swapOffersAndBuild(routes);
        }
        return routes;
    };

    return (
        <Media query={mediaQuery['rnb-mq-large']}>
            {(mediaMatches) => (
                <If condition={!mediaMatches}>
                    <Drawer
                        isCloseable
                        hasBackdrop
                        placement={Drawer.placements.LEFT}
                        theme={Drawer.themes.DARK}
                        dataId={drawerDataId}
                        isOpen={isOpen}
                        onClose={() => {
                            onClose();
                            setIsOpen(false);
                        }}
                    >
                        <div className={styles.content}>
                            <IconNavigation
                                menu="primary"
                                direction="vertical"
                                routerTrackingSource={routerTrackingSource}
                                hasBurgerMenu={hasBurgerMenu}
                                isMoreBurgerMenu={isMoreBurgerMenu}
                                modifyNavigation={modifyNavigation}
                            />
                        </div>
                    </Drawer>
                </If>
            )}
        </Media>
    );
};

BurgerMenu.propTypes = {
    initialIsOpen: PropTypes.bool,
    onClose: PropTypes.func,
    routerTrackingSource: PropTypes.string,
    drawerDataId: PropTypes.string,
    hasBurgerMenu: PropTypes.bool,
    isMoreBurgerMenu: PropTypes.bool,
};

BurgerMenu.defaultProps = {
    initialIsOpen: false,
    onClose: () => {},
    routerTrackingSource: '',
    drawerDataId: '',
    hasBurgerMenu: false,
    isMoreBurgerMenu: false,
};

export default BurgerMenu;
